/****** GESTION DE MAPS INTERACTIVES SVG : permet de rendre un plan svg interactif
 * v1.0
 * dernière modification : 02/06/2021 - Guillaume - 1ère version
 *
 * utilisation :
 * var map = jQuery('.svg-map svg').svgmap({
                selector : '.map-zone.clickable', // selecteur css pour les zones (path) cliquables
                active : '', // selecteur css de la zone active par défaut
                callbackInit : function (map) {
					// la fonction de callback appelée lors de l'instanciation.
					// la var map est l'objet instancié
                },
                callbackMousenter : function (zone,map,event) {
                    // la fonction de callback appelée lors du passage du curseur sur une zone.
                    // la var zone est l'objet jQuery de la zone survolée
					// la var map est l'objet instancié
                },
                callbackMouseleave : function (zone,map,event) {
                    // la fonction de callback appelée lors du départ du curseur depuis une zone.
                    // la var zone est l'objet jQuery de la zone survolée
					// la var map est l'objet instancié
                },
                callbackClick : function (zone,map,event) {
                    // la fonction de callback appelée lors du clic sur une zone.
                    // la var zone est l'objet jQuery de la zone survolée
					// la var map est l'objet instancié
                }
            });

 notes complémentaires :
 des états sont ajoutés automatiquement sur les éléments : hover, is-active.
 l'état cliquable peut être géré en amont, par exemple en ajoutant une classe clickable sur les éléments interactifs et en ajoutant cette classe au sélecteur

 il doit être possible d'instancier plusieurs fois le svg pour définir des zones de clic différenciée avec chacune un comportement spécifique
******/


(function ( $ ) {
	// fonction
	$.fn.svgmap = function( options  ){
		return this.each(function() {
			// objet instancié.
			var element = $(this);

			// paramètres par défaut
			var settings = $.extend({
				selector : '.map-zone',
				active : '',
				NoFilterPossible : true,
				callbackInit : function (map) {
				},
				callbackMousenter : function (zone,map) {
				},
				callbackMouseleave : function (zone,map) {
				},
				callbackClick : function (zone,map) {
				}
			}, options );

			// instanciation
			settings.callbackInit( element );
			element.zones = element.find(settings.selector);
			element.zones
				.on('mouseenter',function(e){
					jQuery(this).addClass('hover');
					settings.callbackMousenter( jQuery(this), element, e );
				})
				.on('mouseleave',function(e){
					jQuery(this).removeClass('hover');
					settings.callbackMouseleave( jQuery(this), element, e );
				})
				.on('click',function(event){

					if( jQuery(this).is('.is-active') && settings.NoFilterPossible ){
						jQuery(this).removeClass('is-active');
					}
					else{
						element.zones.removeClass('is-active');
						jQuery(this).addClass('is-active');
					}

					settings.callbackClick( jQuery(this), element, event );
				});
			element.find( settings.active ).trigger('click');
		});
	};
}( jQuery ));